import { render, staticRenderFns } from "./YChart.vue?vue&type=template&id=60a03868"
import script from "./YChart.vue?vue&type=script&lang=js"
export * from "./YChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports